import { HTTP_INTERCEPTORS } from '@angular/common/http';
import type { Provider } from '@angular/core';

import { DemoBackendInterceptor } from './demo-backend.interceptor';

/**
 * Everything the app needs to serve the demo member from the browser. Spread it into the root
 * providers BEFORE the other HTTP interceptors, so the demo interceptor runs outermost.
 */
export function provideDemoBackend(): Provider[] {
  return [{ provide: HTTP_INTERCEPTORS, useClass: DemoBackendInterceptor, multi: true }];
}
